import Report from "./../../../views/report/ReportQuery"
import Detail from "./../../../views/report/ReportDetail"
export const report = {
    path: '/report',
    name: 'Report',
    component: Report
  }
  export const detail = {
    path: '/detail/:id',
    name: 'Detail',
    component: Detail
  }


// WEBPACK FOOTER //
// ./src/router/index/report/index.js